/* ==========================================================================
   Zayma — Always-visible sticky Add to Cart.
   Mirrors the EXISTING product form: no second form, no second cart API,
   no cart drawer of its own, no checkout logic. The sticky CTA simply fires
   the theme's real Add to Cart button, so Shiprocket Smart Cart, analytics
   and every existing listener behave exactly as before.
   No scroll listeners. No MutationObservers.
   ========================================================================== */
(function () {
  'use strict';

  var SELECT_FLASH_MS = 1800;
  var ADDED_MS = 1400;
  var ADD_TIMEOUT_MS = 6000;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function text(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function ZaymaStickyAtc(bar) {
    this.bar = bar;
    this.cta = bar.querySelector('[data-zsa-cta]');
    this.ctaLabel = bar.querySelector('[data-zsa-cta-label]');
    this.variantEl = bar.querySelector('[data-zsa-variant]');
    this.priceCurrent = bar.querySelector('[data-zsa-price-current]');
    this.priceCompare = bar.querySelector('[data-zsa-price-compare]');

    this.labels = {
      add: bar.getAttribute('data-label-add') || 'ADD TO CART',
      soldOut: bar.getAttribute('data-label-soldout') || 'SOLD OUT',
      adding: bar.getAttribute('data-label-adding') || 'ADDING...',
      added: bar.getAttribute('data-label-added') || 'ADDED',
      select: bar.getAttribute('data-label-select') || 'Select',
      hint: bar.getAttribute('data-label-hint') || 'Please select a size'
    };

    this.showCompare = bar.getAttribute('data-show-compare') === 'true';

    this.available = bar.getAttribute('data-available') === 'true';
    this.needsSelection = false;
    this.busy = false;
    this.adding = false;
    this.showingAdded = false;

    this.addTimer = null;
    this.addPoll = null;
    this.addedTimer = null;
    this.flashTimer = null;

    this.init();
  }

  ZaymaStickyAtc.prototype.productInfo = function () {
    return (
      document.querySelector('product-info[id^="MainProduct"]') ||
      document.querySelector('product-info')
    );
  };

  ZaymaStickyAtc.prototype.sectionId = function () {
    var pi = this.productInfo();
    return pi ? pi.getAttribute('data-section') : null;
  };

  ZaymaStickyAtc.prototype.scope = function () {
    return this.productInfo() || document;
  };

  ZaymaStickyAtc.prototype.submitButton = function () {
    var id = this.sectionId();
    var scope = this.scope();
    return (
      (id && scope.querySelector('#ProductSubmitButton-' + id)) ||
      scope.querySelector('product-form .product-form__submit')
    );
  };

  ZaymaStickyAtc.prototype.variantIdInput = function () {
    var scope = this.scope();
    return scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
  };

  /* ---------- read the EXISTING variant selector (single source of truth) ---------- */
  ZaymaStickyAtc.prototype.optionGroups = function () {
    var vs = this.scope().querySelector('variant-selects');
    var groups = [];
    if (!vs) return groups;

    var fieldsets = vs.querySelectorAll('fieldset.product-form__input');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var legend = fs.querySelector('legend');
      var name = '';
      if (legend) {
        // Swatch legends read "Colour: <span>Maroon</span>" — take the label only.
        name = (legend.childNodes[0] && legend.childNodes[0].textContent) || legend.textContent || '';
        name = name.replace(/\s+/g, ' ').replace(/:\s*$/, '').trim();
      }
      var checked = fs.querySelector('input[type="radio"]:checked');
      groups.push({ name: name, value: checked ? checked.value : null, el: fs });
    }

    var selects = vs.querySelectorAll('.product-form__input--dropdown select');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      var raw = sel.getAttribute('name') || '';
      var m = raw.match(/options\[(.+)\]/);
      groups.push({
        name: m ? m[1] : '',
        value: sel.value || null,
        el: sel.closest('.product-form__input') || sel
      });
    }

    return groups;
  };

  ZaymaStickyAtc.prototype.sizeGroup = function () {
    var groups = this.optionGroups();
    if (!groups.length) return null;
    for (var i = 0; i < groups.length; i++) {
      if ((groups[i].name || '').toLowerCase().indexOf('size') !== -1) return groups[i];
    }
    return groups[0];
  };

  /* ---------- read the price straight from the PDP's own price block ---------- */
  ZaymaStickyAtc.prototype.readPrice = function () {
    var id = this.sectionId();
    var host = id ? document.getElementById('price-' + id) : null;
    if (!host) host = this.scope().querySelector('.price');
    if (!host) return null;

    var priceEl = host.classList && host.classList.contains('price') ? host : host.querySelector('.price');
    if (!priceEl) return null;

    var onSale = priceEl.classList.contains('price--on-sale');
    var current = onSale
      ? priceEl.querySelector('.price__sale .price-item--sale')
      : priceEl.querySelector('.price__regular .price-item--regular');
    var compare = onSale ? priceEl.querySelector('.price__sale s.price-item--regular') : null;

    return { current: text(current), compare: text(compare) };
  };

  /* ---------- state ---------- */
  ZaymaStickyAtc.prototype.sync = function () {
    var group = this.sizeGroup();

    if (!group) {
      this.needsSelection = false;
      if (this.variantEl) this.variantEl.hidden = true;
    } else if (this.variantEl) {
      this.variantEl.hidden = false;
      if (group.value) {
        this.needsSelection = false;
        this.variantEl.textContent = (group.name ? group.name + ': ' : '') + group.value;
      } else {
        this.needsSelection = true;
        this.variantEl.textContent = (group.name || 'Size') + ': ' + this.labels.select;
      }
    }

    var price = this.readPrice();
    if (price && this.priceCurrent) {
      if (price.current) this.priceCurrent.textContent = price.current;
      if (this.priceCompare) {
        var showCompare = this.showCompare && price.compare && price.compare !== price.current;
        this.priceCompare.textContent = showCompare ? price.compare : '';
        this.priceCompare.hidden = !showCompare;
      }
    }

    var btn = this.submitButton();
    if (btn) {
      this.available = !btn.hasAttribute('disabled');
    } else {
      var input = this.variantIdInput();
      if (input) this.available = !!input.value;
    }

    this.render();
  };

  ZaymaStickyAtc.prototype.render = function () {
    var label;
    var disabled = false;

    if (this.adding) {
      label = this.labels.adding;
      disabled = true;
    } else if (this.showingAdded) {
      label = this.labels.added;
      disabled = true;
    } else if (!this.available && !this.needsSelection) {
      label = this.labels.soldOut;
      disabled = true;
    } else {
      label = this.labels.add;
    }

    if (this.ctaLabel) this.ctaLabel.textContent = label;

    this.bar.classList.toggle('is-soldout', !this.adding && !this.showingAdded && !this.available && !this.needsSelection);
    this.bar.classList.toggle('is-busy', this.busy);

    if (this.cta) {
      this.cta.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      if (disabled) {
        this.cta.setAttribute('disabled', 'disabled');
      } else {
        this.cta.removeAttribute('disabled');
      }
    }

    this.measure();
  };

  /* ---------- "no size selected" guidance (no popups) ---------- */
  ZaymaStickyAtc.prototype.promptSelection = function () {
    var group = this.sizeGroup();
    if (!group || !group.el) return;

    var host = group.el;
    var hint = host.querySelector('.zayma-size-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'zayma-size-hint';
      hint.setAttribute('role', 'status');
      host.appendChild(hint);
    }
    hint.textContent = this.labels.hint;
    hint.hidden = false;

    try {
      host.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      host.scrollIntoView();
    }

    host.classList.add('zayma-size-flash');
    clearTimeout(this.flashTimer);
    var self = this;
    this.flashTimer = setTimeout(function () {
      host.classList.remove('zayma-size-flash');
    }, SELECT_FLASH_MS);
  };

  ZaymaStickyAtc.prototype.clearHint = function () {
    var hint = this.scope().querySelector('.zayma-size-hint');
    if (hint) hint.hidden = true;
  };

  /* ---------- add to cart, through the theme's own button ---------- */
  ZaymaStickyAtc.prototype.onCtaClick = function (event) {
    event.preventDefault();

    if (this.adding || this.showingAdded) return;

    if (this.needsSelection) {
      this.promptSelection();
      return;
    }

    if (!this.available) return;

    var btn = this.submitButton();
    if (!btn) return;

    this.adding = true;
    this.render();

    var self = this;
    clearTimeout(this.addTimer);
    this.addTimer = setTimeout(function () {
      self.finishAdd(false);
    }, ADD_TIMEOUT_MS);

    // Fires every existing listener on the real button: theme AJAX add,
    // Shiprocket Smart Cart, pixels and analytics included.
    btn.click();

    // Safety net in case the pub/sub cart events never arrive.
    clearInterval(this.addPoll);
    var started = Date.now();
    var sawLoading = false;
    this.addPoll = setInterval(function () {
      if (!self.adding) {
        clearInterval(self.addPoll);
        return;
      }
      var loading = btn.classList.contains('loading');
      if (loading) sawLoading = true;
      var elapsed = Date.now() - started;
      if (!loading && (sawLoading || elapsed > 1200) && elapsed > 600) {
        clearInterval(self.addPoll);
        self.finishAdd(true);
      }
    }, 250);
  };

  ZaymaStickyAtc.prototype.finishAdd = function (success) {
    if (!this.adding) return;

    clearTimeout(this.addTimer);
    clearInterval(this.addPoll);
    this.adding = false;

    if (success && this.labels.added) {
      this.showingAdded = true;
      this.render();
      var self = this;
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(function () {
        self.showingAdded = false;
        self.sync();
      }, ADDED_MS);
    } else {
      this.sync();
    }
  };

  /* ---------- height, so page content clears the bar ---------- */
  ZaymaStickyAtc.prototype.measure = function () {
    if (this.bar.hidden) return;
    var h = Math.round(this.bar.getBoundingClientRect().height);
    if (h && h !== this.lastHeight) {
      this.lastHeight = h;
      document.documentElement.style.setProperty('--zayma-sticky-atc-h', h + 'px');
    }
  };

  /* ---------- wiring ---------- */
  ZaymaStickyAtc.prototype.init = function () {
    var self = this;

    document.body.classList.add('zayma-has-sticky-atc');
    if (this.bar.classList.contains('zayma-sticky-atc--desktop-only')) {
      document.body.classList.add('zayma-sticky-desktop-only');
    }
    if (this.bar.classList.contains('zayma-sticky-atc--mobile-only')) {
      document.body.classList.add('zayma-sticky-mobile-only');
    }

    if (this.cta) {
      this.cta.addEventListener('click', function (e) {
        self.onCtaClick(e);
      });
    }

    // The customer touching the real selector: show the label immediately and
    // mark the bar busy until the theme has finished swapping the variant in.
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.closest('variant-selects')) {
        self.busy = true;
        self.clearHint();
        var group = self.sizeGroup();
        if (group && group.value && self.variantEl) {
          self.variantEl.textContent = (group.name ? group.name + ': ' : '') + group.value;
          self.needsSelection = false;
        }
        self.render();
        return;
      }

      // Dawn dispatches this after it has resolved the new variant.
      // An empty value means the chosen combination does not exist.
      if (target.matches && target.matches('form[data-type="add-to-cart-form"] input[name="id"]')) {
        if (!target.value) {
          self.busy = false;
          self.available = false;
          self.render();
        }
      }
    });

    // Full, authoritative refresh — price and CTA state are settled by now.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        self.busy = false;
        self.sync();
      });
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (self.adding) self.finishAdd(true);
      });
      subscribe(PUB_SUB_EVENTS.cartError, function () {
        if (self.adding) self.finishAdd(false);
      });
    }

    // A combined-listing swap replaces the whole product-info element.
    document.addEventListener('product-info:loaded', function () {
      self.busy = false;
      self.sync();
    });

    if (typeof ResizeObserver === 'function') {
      this.resizeObserver = new ResizeObserver(function () {
        self.measure();
      });
      this.resizeObserver.observe(this.bar);
    } else {
      window.addEventListener('resize', function () {
        self.measure();
      });
      window.addEventListener('orientationchange', function () {
        self.measure();
      });
    }

    this.sync();
    this.measure();
    window.requestAnimationFrame(function () {
      self.measure();
    });
  };

  ready(function () {
    var bar = document.getElementById('ZaymaStickyAtc');
    if (!bar) return;
    if (!document.querySelector('product-info, form[data-type="add-to-cart-form"]')) {
      bar.hidden = true;
      return;
    }
    window.zaymaStickyAtc = new ZaymaStickyAtc(bar);
  });
})();